module.exports = __webpack_public_path__ + "img/douyin.5a6e7199.png";